(function () {
    const SELECTOR = '[data-cart-gift]';
    const NOTE_MAX = 200;

    const RECIPIENT_ATTR = 'Ship to recipient';
    const MODE_ATTR = 'gift_card_mode';
    const NOTE_PROPERTY = 'Gift Note';

    let writing = Promise.resolve();

    function post(url, data) {
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Cart request failed: ${response.status}`);
            }

            return response.json();
        });
    }

    function refreshCart() {
        document.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
        );
    }

    function queue(task) {
        writing = writing
            .then(task)
            .catch(error => {
                console.error('[Cart Gift]', error);
            });

        return writing;
    }

    function getCart() {
        return fetch('/cart.js').then(response => response.json());
    }


    function init(root) {
        if (!root || root.dataset.giftInitialized === 'true') return;

        root.dataset.giftInitialized = 'true';

        const recipientToggle = root.querySelector('[data-gift-recipient]');
        const recipientNote = root.querySelector('[data-gift-recipient-note]');

        const cardToggle = root.querySelector('[data-gift-card-toggle]');
        const expand = root.querySelector('[data-gift-expand]');

        const cards = root.querySelectorAll('[data-gift-card]');
        const modes = root.querySelectorAll('[data-gift-mode]');

        const textareaWrap = root.querySelector('[data-gift-textarea]');
        const textarea = root.querySelector('[data-gift-note]');
        const counter = root.querySelector('[data-gift-count]');
        const help = root.querySelector('[data-gift-mode-help]');

        const feeVariantId = Number(root.dataset.handwritingVariant);

        let selectedCard = null;
        let mode = 'blank';


        function setToggle(toggle, value) {
            toggle.setAttribute('aria-checked', value ? 'true' : 'false');
        }


        function setMode(newMode) {
            mode = newMode;

            modes.forEach(button => {
                const active = button.dataset.giftMode === mode;

                button.classList.toggle('active', active);
                button.setAttribute('aria-pressed', active ? 'true' : 'false');
            });

            if (mode === 'write') {
                textareaWrap.hidden = false;

                help.textContent =
                    'Our team hand-letters your note inside the card before it ships.';
            } else {
                textareaWrap.hidden = true;

                help.textContent =
                    "We'll tuck it in unwritten so you can fill it in yourself.";
            }
        }


        function updateCounter() {
            counter.textContent = textarea.value.length;
        }


        function removeGreetingCards() {
            const variantIds = Array.from(cards).map(card =>
                Number(card.dataset.variantId)
            );

            return getCart().then(cart => {
                const matches = cart.items.filter(item =>
                    variantIds.includes(item.variant_id)
                );

                return matches.reduce((promise, item) => {
                    return promise.then(() =>
                        post('/cart/change.js', {
                            id: item.key,
                            quantity: 0
                        })
                    );
                }, Promise.resolve());
            });
        }


        function removeFee() {
            if (!feeVariantId) return Promise.resolve();

            return getCart().then(cart => {
                const matches = cart.items.filter(
                    item => item.variant_id === feeVariantId
                );

                return matches.reduce((promise, item) => {
                    return promise.then(() =>
                        post('/cart/change.js', {
                            id: item.key,
                            quantity: 0
                        })
                    );
                }, Promise.resolve());
            });
        }


        function addFee() {
            if (!feeVariantId) return Promise.resolve();

            return removeFee().then(() => {
                return post('/cart/add.js', {
                    items: [{
                        id: feeVariantId,
                        quantity: 1,
                        properties: {
                            [NOTE_PROPERTY]: textarea.value
                        }
                    }]
                });
            });
        }


        function saveNote() {
            if (mode !== 'write' || !feeVariantId) return;

            queue(() => {
                return getCart()
                    .then(cart => {
                        const line = cart.items.find(
                            item => item.variant_id === feeVariantId
                        );

                        if (!line) {
                            return addFee();
                        }

                        return post('/cart/change.js', {
                            id: line.key,
                            quantity: line.quantity || 1,
                            properties: {
                                [NOTE_PROPERTY]: textarea.value
                            }
                        });
                    })
                    .then(refreshCart);
            });
        }


        let noteTimer;

        textarea.addEventListener('input', function () {
            if (textarea.value.length > NOTE_MAX) {
                textarea.value = textarea.value.slice(0, NOTE_MAX);
            }

            updateCounter();

            clearTimeout(noteTimer);
            noteTimer = setTimeout(saveNote, 600);
        });


        recipientToggle.addEventListener('click', function () {
            const enabled =
                recipientToggle.getAttribute('aria-checked') !== 'true';

            setToggle(recipientToggle, enabled);
            recipientNote.hidden = !enabled;

            post('/cart/update.js', {
                attributes: {
                    [RECIPIENT_ATTR]: enabled ? 'Yes' : 'No'
                }
            });
        });


        cardToggle.addEventListener('click', function () {
            const enabled =
                cardToggle.getAttribute('aria-checked') !== 'true';

            setToggle(cardToggle, enabled);
            expand.hidden = !enabled;

            if (!enabled) {
                selectedCard = null;

                cards.forEach(card => {
                    card.setAttribute('aria-checked', 'false');
                });

                textarea.value = '';
                updateCounter();

                setMode('blank');

                queue(() =>
                    removeGreetingCards()
                        .then(removeFee)
                        .then(() =>
                            post('/cart/update.js', {
                                attributes: {
                                    [MODE_ATTR]: 'blank'
                                }
                            })
                        )
                        .then(refreshCart)
                );
            }
        });


        cards.forEach(card => {
            card.addEventListener('click', function () {
                const variantId = Number(card.dataset.variantId);

                if (!variantId || selectedCard === variantId) return;

                selectedCard = variantId;

                cards.forEach(item => {
                    item.setAttribute(
                        'aria-checked',
                        item === card ? 'true' : 'false'
                    );
                });

                queue(() =>
                    removeGreetingCards()
                        .then(() =>
                            post('/cart/add.js', {
                                items: [{
                                    id: variantId,
                                    quantity: 1
                                }]
                            })
                        )
                        .then(refreshCart)
                );
            });
        });


        modes.forEach(button => {
            button.addEventListener('click', function () {
                const newMode = button.dataset.giftMode;

                if (newMode === mode) return;

                setMode(newMode);

                queue(() => {
                    return post('/cart/update.js', {
                        attributes: {
                            [MODE_ATTR]: newMode
                        }
                    })
                    .then(() => {
                        if (newMode === 'write') {
                            return addFee();
                        }

                        return removeFee();
                    })
                    .then(refreshCart);
                });
            });
        });


        // Restore existing cart state
        getCart().then(cart => {
            const attrs = cart.attributes || {};

            const recipientEnabled =
                attrs[RECIPIENT_ATTR] === 'Yes';

            setToggle(recipientToggle, recipientEnabled);
            recipientNote.hidden = !recipientEnabled;


            const cardLine = cart.items.find(item => {
                return Array.from(cards).some(card =>
                    Number(card.dataset.variantId) === item.variant_id
                );
            });

            if (cardLine) {
                selectedCard = cardLine.variant_id;

                setToggle(cardToggle, true);
                expand.hidden = false;

                cards.forEach(card => {
                    card.setAttribute(
                        'aria-checked',
                        Number(card.dataset.variantId) === selectedCard
                            ? 'true'
                            : 'false'
                    );
                });
            }


            const feeLine = cart.items.find(
                item => item.variant_id === feeVariantId
            );

            if (feeLine) {
                setToggle(cardToggle, true);
                expand.hidden = false;

                setMode('write');

                if (
                    feeLine.properties &&
                    feeLine.properties[NOTE_PROPERTY]
                ) {
                    textarea.value =
                        feeLine.properties[NOTE_PROPERTY];
                }

                updateCounter();
            } else {
                setMode('blank');
            }
        });
    }


    function initialize() {
        document.querySelectorAll(SELECTOR).forEach(init);
    }

    initialize();

    // Cart drawer may be re-rendered by Shopify/theme
    const observer = new MutationObserver(initialize);

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();